interface ObjectWithId<T> {
  id?: T;
}

export const sortByIds = <ID, T extends ObjectWithId<ID>>(ids: ID[], data: T[]): T[] => {
  return ids.map(id => data.find(row => row.id === id)!!).filter(row => !!row);
};
